import { ApiBoardSettingsResponse } from '../../../api/core/models';
import { EmissionFactorCalculationMethod } from '../../../model/enums/emission-factor-calculation-method';

export function apiBoardSettingsToElectricityEmissionFactorType(
  apiBoardSettings?: ApiBoardSettingsResponse
): EmissionFactorCalculationMethod {
  if (apiBoardSettings?.electricityEmissionFactorType === 'IMPORTED_GRID') {
    return EmissionFactorCalculationMethod.ImportedGrid;
  }
  return EmissionFactorCalculationMethod.Calculated;
}
